import { type Column, flexRender, type Row } from '@tanstack/react-table';
import { type AppTableFeatures } from '../react-table-features';

import { type PinConfig, TableCell } from '../table-cell/TableCell';
import type { RevampTableRow } from './RevampTable.types';
import {
  getRevampTableCellAlignment,
  isNumericColumnType,
  isRevampTableColumn,
} from './utils';

interface RevampTableBodyRowProps {
  row: Row<AppTableFeatures, RevampTableRow>;
  getPinConfig: (
    column: Column<AppTableFeatures, RevampTableRow>
  ) => PinConfig | undefined;
  onRowClick?: (row: Row<AppTableFeatures, RevampTableRow>) => void;
}

export const RevampTableBodyRow = ({
  row,
  getPinConfig,
  onRowClick,
}: RevampTableBodyRowProps) => (
  <tr onClick={onRowClick ? () => onRowClick(row) : undefined}>
    {row.getVisibleCells().map(cell => {
      const meta = cell.column.columnDef.meta;
      const column = isRevampTableColumn(meta) ? meta : undefined;

      return (
        <TableCell
          key={cell.id}
          alignment={column ? getRevampTableCellAlignment(column) : undefined}
          isNumber={
            !!column && (column.isNumber ?? isNumericColumnType(column.type))
          }
          pinConfig={getPinConfig(cell.column)}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      );
    })}
  </tr>
);
